import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config/api';
import { useEmberPrice } from '../hooks/useEmberPrice';

function StatCard({ label, value, highlight }) {
  return (
    <div style={{
      flex: '1 1 0',
      minWidth: '120px',
      backgroundColor: '#111',
      border: '1px solid #2a2a2a',
      borderRadius: '10px',
      padding: '14px 16px',
      textAlign: 'center',
    }}>
      <div style={{ color: '#6b7280', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '6px' }}>
        {label}
      </div>
      <div style={{ color: highlight ? '#FB923C' : '#fff', fontSize: '1.25rem', fontWeight: '700', letterSpacing: '-0.01em' }}>
        {value}
      </div>
    </div>
  );
}

function StatsBar() {
  const [stats, setStats] = useState(null);
  const { priceInUSD, priceInFLR, error: priceError } = useEmberPrice(); // Fetch $EMBER price from DEX

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/stats`);
        const data = await res.json();
        setStats(data);
      } catch (e) {
        console.error('[StatsBar] failed to load stats', e);
      }
    };
    load();
    const interval = setInterval(load, 60_000); // refresh every minute
    return () => clearInterval(interval);
  }, []);

  const fmt = (n) => n == null ? '—' : Number(n).toLocaleString();
  const fmtUsd = (n) => {
    if (n == null) return '—';
    const price = parseFloat(n);
    // For prices < $0.01, show up to 8 decimals to avoid showing $0.0000
    if (price < 0.01) {
      return `$${price.toFixed(8)}`;
    }
    return `$${price.toFixed(4)}`;
  };

  // Determine what to show for EMBER price
  const getEmberPriceDisplay = () => {
    if (priceError === 'FLR price unavailable') {
      // We have EMBER/FLR ratio but can't convert to USD
      if (priceInFLR != null) {
        return `${priceInFLR.toFixed(6)} FLR`;
      }
      return '⚠️ Oracle Error';
    } else if (priceError === 'Pool has insufficient liquidity') {
      // Pool exists but is empty or has invalid reserves
      return '⚠️ Empty Pool';
    } else if (priceError) {
      // No liquidity pool or other error
      return '⚠️ No Pool';
    } else {
      // Normal case - show USD price
      return fmtUsd(priceInUSD);
    }
  };

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      padding: '0 16px 20px',
      maxWidth: '700px',
      margin: '0 auto',
      width: '92%',
    }}>
      <StatCard label="Bridge Transactions" value={fmt(stats?.total_transactions)} />
      <StatCard label="Tokens Supported" value={fmt(stats?.tokens_supported)} />
      <StatCard
        label="$EMBER Price"
        value={getEmberPriceDisplay()}
        highlight={!priceError || priceError === 'FLR price unavailable'} // Show in orange if working or if just FLR oracle failed
      />
      <StatCard label="Tokens Locked" value={stats?.tvl_usd == null ? '—' : Number(stats.tvl_usd).toLocaleString()} />
    </div>
  );
}

export default StatsBar;
